// localStorage can throw where the browser blocks storage, e.g. a portal page
// embedded on another website (Safari, strict privacy settings). Reads that
// run on every page load go through here so the page still renders.
export function readStorage(key) {
	try {
		return localStorage.getItem(key);
	} catch (e) {
		return null;
	}
}
